<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="20">
        <el-col :span="24">
          <el-card class="box-card">
            <h4 class="card-title">Classroom Feedback</h4>
            <div class="card-header">

              <div class="card-content">

                <el-row style="margin-top:30px; margin-bottom: 10px">

                </el-row>

                <data-tables-server 
                  class="table-shopping" 
                  style="width: 100%" 
                  :data="feedback" 
                  :tool-bar="false" 
                  :current-page="1" 
                  :total="total"
                  :loading="loadingFeedback"
                  :page-size="20"
                  :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }">

                  <el-table-column label="Name" min-width="10">
                    <template slot-scope="props" v-if="props.row.customer">{{props.row.customer.firstname}} {{props.row.customer.lastname}}</template>
                  </el-table-column>

                  <el-table-column label="Date" min-width="10">
                    <template slot-scope="props">{{props.row.dateUpdated | moment('DD MMM YYYY')}}</template>
                  </el-table-column>

                  <el-table-column label="Rating" min-width="8">
                    <template slot-scope="props">{{props.row.tutorRating}}/10</template>
                  </el-table-column>

                  <el-table-column label="What did the student like most" min-width="40">
                    <template slot-scope="props">{{props.row.likeMost}}</template>
                  </el-table-column>

                  <el-table-column label="What would the student improve" min-width="40">
                    <template slot-scope="props">{{props.row.improve}}</template>
                  </el-table-column>

                </data-tables-server>
              </div>
            </div>
            <div class="card-content"></div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import api from "./api";
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
export default {
  data() {
    return {
      classroom: {},
      feedback:[],
      printRegister:'',
      loadingFeedback: false,
      total: 0,
      aggregate: {}
    };
  },
  methods: {

    getFeedback(id) {

      this.$apollo
      .query({
        // desc_nulls_last filters out any null data
        query: gql`
          {
            ClassRoomFeedback(
              where: { 
                  _and: [
                    { classRoomId: {_eq: "${id}"} }
                  ]
                }
            ) {
                id
                tutorRating
                customer {
                  firstname
                  lastname
                }
                likeMost
                improve
                dateUpdated
            }
            ClassRoomFeedback_aggregate(
              where: { 
                 _and: [
                    { classRoomId: {_eq: "${id}"} }
                  ]
                }
            ) {
              aggregate {
                count
              }
            }
          }
        `,
        // can get error if needed
        error(error) {
          this.error = JSON.stringify(error);
        }
      })
      .then(response => {
        this.feedback = response.data.ClassRoomFeedback;
        //console.log(this.feedback);
        this.aggregate = response.data.ClassRoomFeedback_aggregate.aggregate;
        this.total = response.data.ClassRoomFeedback_aggregate.aggregate.count;
        this.loadingFeedback = false;
      });
    },

    
    
  },
  mounted() {
    //this.getRegister(this.$route.params.id);
    this.getFeedback(this.$route.params.id);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Tutor/Feedback.vue